export const APP_ACTION_TYPES = {
  GLOBAL_CLEAR_STATE: 'GLOBAL_CLEAR_STATE',
};

export function clearStore() {
  return {
    type: APP_ACTION_TYPES.GLOBAL_CLEAR_STATE,
  };
}
